import { Tooltip, TooltipProps } from '@material-ui/core';
import React from 'react';

interface DisableableTooltipProps extends TooltipProps {
  disabled?: boolean
}

const DisableableTooltip = (props: DisableableTooltipProps) => {
  const {disabled, children, ...rest} = props;

  return disabled ? children:<Tooltip {...rest}>
    <span>
      {children}
    </span>
  </Tooltip>
};

export default DisableableTooltip;